import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, UrlTree } from '@angular/router';
import { StorageService } from '@app/data/browser/storage.service';
import { AppFacade } from '@app/facades/app.facade';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_ROUTES as ROUTES } from '@app/app.routes';

@Injectable({
  providedIn: 'root',
})
export class ValidationsGuard implements CanActivate, CanLoad {
  constructor(
    private _appFacade: AppFacade,
    private _storageService: StorageService,
    private _router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this._checkValidationsPage();
  }

  canLoad(): Observable<boolean | UrlTree> {
    return this._checkValidationsPage();
  }

  private _checkValidationsPage(): Observable<boolean | UrlTree> {
    return combineLatest([
      this._isValidationsChecked(),
      this._appFacade.purchaseLessOnboardingFlag$,
    ]).pipe(
      map(([isValidationsChecked, isPurchaselessOnboarding]) => {
        const flag: boolean = !isPurchaselessOnboarding
          ? this._storageService.getItem('purchaseLessOnboarding')
          : isPurchaselessOnboarding;
        const route: string = !!flag ? ROUTES.PURCHASELESS_ONBOARDING : ROUTES.WAITING_ROOM;
        return isValidationsChecked ? true : this._router.createUrlTree([route]);
      })
    );
  }

  private _isValidationsChecked(): Observable<boolean> {
    return combineLatest([
      this._appFacade.transactions$,
      this._appFacade.session$,
      this._appFacade.purchaseLessOnboardingFlag$,
    ]).pipe(
      map(([transactions, session, isPurchaselessOnboarding]) => {
        return (!!transactions && !!session) || (!!session && !!isPurchaselessOnboarding);
      })
    );
  }
}
